// Color bubbles for the "Product Grid + Banner" section.
//
// Elsewhere the bubbles are driven by the `collection.js` snippet, which is only
// rendered by `main-collection-rocket`. Templates that disable that section (e.g.
// collection.metal-26) still show this section, so it ships its own product data
// (a JSON script tag per section) and its own handlers.

(function () {
  var TAG_LABELS = ['best seller', 'new in', 'premium', 'limited'];

  // Measured per call rather than once at load: the viewport is not settled when a
  // deferred script runs, and the window can still be resized afterwards.
  function isMobile() {
    return window.innerWidth < 800;
  }

  function readData(section) {
    if (section.pgbProducts) return section.pgbProducts;

    var node = section.querySelector('.pgb__data');

    try {
      section.pgbProducts = JSON.parse(node.textContent);
    } catch (err) {
      section.pgbProducts = {};
    }

    return section.pgbProducts;
  }

  function renderTags(item, data, collabLabel) {
    var tags = item.querySelector('.tags');
    if (!tags) return;

    tags.innerHTML = '';

    var hasLab = data.tags.some(function (t) {
      return t.toLowerCase() === 'lab';
    });
    var hasCollab = data.tags.some(function (t) {
      return t.toLowerCase().indexOf('collab') !== -1;
    });

    if (hasLab || hasCollab) {
      var label = document.createElement('li');

      label.textContent = hasLab ? 'MELLER LAB' : collabLabel;
      tags.appendChild(label);
      return;
    }

    data.tags.forEach(function (t) {
      var tag = t.toLowerCase();
      if (TAG_LABELS.indexOf(tag) === -1) return;

      var li = document.createElement('li');

      li.textContent = tag;
      tags.appendChild(li);
    });
  }

  function updateAddToCart(item, data, id) {
    var button = item.querySelector('form button');
    if (!button) return;

    var variantInput = item.querySelector('input[name="id"]');
    var productInput = item.querySelector('input[name="product-id"]');
    var available = item.querySelector('#available');
    var soldOut = item.querySelector('#sold_out');

    if (variantInput) variantInput.value = data.variant_id;
    if (productInput) productInput.value = id;

    button.disabled = !data.available;
    if (available) available.hidden = !data.available;
    if (soldOut) soldOut.hidden = data.available;
  }

  function updateImages(item, data) {
    var featured = item.querySelector('figure img:not(.second_img)');
    var second = item.querySelector('figure .second_img');
    var imgWidth = isMobile() ? 400 : 640;

    if (featured && data.featured_image) {
      featured.src = data.featured_image + '&width=' + imgWidth;
      featured.srcset = '';
      featured.alt = data.title;
    }

    // Fall back to the featured image so the hover state never keeps showing the
    // previously selected color when this one has a single image.
    var hover = data.images.length > 1 ? data.images[1] : data.featured_image;

    if (second && !isMobile() && hover) {
      second.src = hover + '&width=' + imgWidth;
      second.srcset = '';
    }
  }

  function updatePrice(item, data) {
    var price = item.querySelector('.info .price');
    if (!price) return;

    price.innerHTML = '';

    if (!data.compare_at_price) {
      price.textContent = data.price;
      return;
    }

    var amounts = { original: data.compare_at_price, discounted: data.price };

    Object.keys(amounts).forEach(function (kind) {
      var span = document.createElement('span');

      span.classList.add(kind);
      span.textContent = amounts[kind];
      price.appendChild(span);
    });
  }

  function selectColor(e) {
    var bubble = e.currentTarget;
    var item = bubble.closest('.product-item');
    var section = item && item.closest('.pgb');

    if (!section) return;

    var id = bubble.dataset.id;
    if (item.dataset.id === id) return;

    var group = readData(section)[item.dataset.collection];
    var data = group && group[id];

    if (!data) return;

    item.querySelectorAll('.selector li').forEach(function (li, index) {
      var isSelected = li.dataset.id === id;

      li.classList.toggle('selected', isSelected);

      if (!isSelected) return;

      // analytics
      try {
        gtag('event', 'select_bubble', { handle: data.handle, index: index + 1 });
      } catch (err) {
        /* gtag is not always loaded */
      }
    });

    renderTags(item, data, section.dataset.collabLabel);
    updateAddToCart(item, data, id);
    updateImages(item, data);
    updatePrice(item, data);

    item.querySelectorAll('a').forEach(function (a) {
      a.href = data.url;
    });

    item.dataset.id = id;
  }

  function init(section) {
    section.dataset.pgbReady = 'true';

    section.querySelectorAll('.selector li').forEach(function (li) {
      li.addEventListener('click', selectColor);
      li.addEventListener('mouseover', selectColor);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.pgb:not([data-pgb-ready])').forEach(init);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
